import { FormikHelpers, FormikProps } from 'formik';
import { RetirementInterface } from './model';

import { SingleValueResponse } from 'common/interfaces';
import { API_ACCOUNT_FINANCE_RETIREMENT, API_ACCOUNT_DETAIL_FINANCE_RETIREMENT } from 'api/endpoints';

import { FormStore } from 'stores/formStore';
import { RootStore } from 'stores/rootStore';
import { RentModalsStore } from 'stores/workflowStores/finances/rentModalsStore';

export class WorkflowRetirementStore extends FormStore<RetirementInterface> {
  rentModalsStore: RentModalsStore;
  detailMode?: boolean;

  constructor(rootStore: RootStore, accountId: string, rentModalsStore: RentModalsStore, detailMode?: boolean) {
    super(rootStore);
    this.accountId = accountId;
    this.rentModalsStore = rentModalsStore;
    this.detailMode = detailMode;
  }

  fetchRetirement = async () => {
    this.rentModalsStore.setLoading(true);
    await this.fetchData(
      this.detailMode
        ? API_ACCOUNT_DETAIL_FINANCE_RETIREMENT(this.accountId)
        : API_ACCOUNT_FINANCE_RETIREMENT(this.accountId),
      { resetData: false },
    );
    this.rentModalsStore.setLoading(false);
  };

  calcTotalIncome = async (formikProps: FormikProps<RetirementInterface>) => {
    const { post, get } = this.rootStore.stores.apiStore;
    const { values, setFieldValue } = formikProps;

    const postResponspse = await post<SingleValueResponse<boolean>>(
      this.detailMode
        ? API_ACCOUNT_DETAIL_FINANCE_RETIREMENT(this.accountId)
        : API_ACCOUNT_FINANCE_RETIREMENT(this.accountId),
      values,
    );
    if (postResponspse && postResponspse.data && postResponspse.data.value) {
      const getResponse = await get<RetirementInterface>(
        this.detailMode
          ? API_ACCOUNT_DETAIL_FINANCE_RETIREMENT(this.accountId)
          : API_ACCOUNT_FINANCE_RETIREMENT(this.accountId),
      );
      if (getResponse && getResponse.data) {
        setFieldValue('totalIncome', getResponse.data.totalIncome);
      }
    }
  };

  handleSubmit = async (values: RetirementInterface, formikHelpers: FormikHelpers<RetirementInterface>) => {
    const { onNextRentTab } = this.rentModalsStore;
    if (
      values.extraIncome?.length === 1 &&
      values.extraIncome[0].type === '' &&
      values.extraIncome[0].value.value === 0
    ) {
      values.extraIncome = [];
    }
    const ok = await this.submitData(
      this.detailMode
        ? API_ACCOUNT_DETAIL_FINANCE_RETIREMENT(this.accountId)
        : API_ACCOUNT_FINANCE_RETIREMENT(this.accountId),
      values,
      {
        formikHelpers,
        singleValueResponse: true,
        reset: false,
        validationPrefixDepth: 3,
      },
    );

    if (ok) {
      this.fetchRetirement();
      onNextRentTab();
    }
  };
}
